import { render } from "./CloseIcon.vue?vue&type=template&id=62257950&scoped=true"
const script = {}

import "./CloseIcon.vue?vue&type=style&index=0&id=62257950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62257950"]])

export default __exports__